module.exports = __webpack_public_path__ + "img/user-icon-image-7.47621c6e.jpg";